import { PileBadge, styled } from '@ingrid/luterkort-react';

import { environment } from '~src/config/config';

const Badge = styled(PileBadge, {
  backgroundColor: 'var(--purple)',
  color: 'white',

  variants: {
    mode: {
      dark: {
        backgroundColor: 'var(--purple)',
      },
    },
  },
});

function getEnvironmentName() {
  switch (environment) {
    case 'development.local':
      return 'Development (local)';
    case 'development.deploy':
      return 'Development';
    case 'stage':
      return 'Stage';
  }

  return null;
}

export function Environment() {
  const name = getEnvironmentName();

  if (!name) {
    return false;
  }

  return <Badge>{name}</Badge>;
}
